import { AllowedFileType } from '../form-certificate-file-picker/types';

export type { CertificateUploadFormValues } from './schema';

export const ACCEPTED_FILE_TYPES: AllowedFileType[] = ['.pdf', '.jpg', '.jpeg', '.png'];
